/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-underscore-dangle */

import React, { useEffect, useState, useRef, useMemo } from "react";
import MDBox from "components/MDBox";
import { Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "examples/Tables/DataTable";
import FilterDropdown from "components/Dropdown/FilterDropdown";
import CustomSearch from "components/Search/Search";
import ResetFilterButton from "components/Buttons/ResetButton";
import ConfirmationModal from "examples/modal/Confirmation/Confirmation";
import pxToRem from "assets/theme/functions/pxToRem";
import Constants, { defaultData } from "utils/Constants";
import Session from "utils/Sessions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { openSnackbar } from "redux/Slice/Notification";

import inquiriesTableData from "dataTables/inquiries/inquiriesTable";
import AddInquiryModal from "examples/modal/InquiryModal/AddInquiryModal";
import EditInquiryModal from "examples/modal/InquiryModal/EditInquiryModal";
import ProcessInquiryModal from "examples/modal/InquiryModal/ProcessInquiryModal";
import RejectInquiryModal from "examples/modal/InquiryModal/RejectInquiryModal";
import {
  createInquiryThunk,
  deleteInquiryThunk,
  getAllInquiriesThunk,
  updateInquiryStatusThunk,
  updateInquiryThunk,
} from "redux/Thunks/Inquiry";
import { removeInquiryFromList, updateInquiryInList } from "redux/Slice/Inquiry.slice";
import { getAllSalesManagers } from "redux/Thunks/leadUtilsThunks";
import { paramCreater } from "utils/methods/methods";

const STATUS_FILTER_OPTIONS = [
  { [Constants.MONGOOSE_ID]: "all", title: "All Statuses" },
  { [Constants.MONGOOSE_ID]: "pending", title: "Pending" },
  { [Constants.MONGOOSE_ID]: "processed", title: "Processed" },
  { [Constants.MONGOOSE_ID]: "rejected", title: "All Rejected" },
  { [Constants.MONGOOSE_ID]: "rejected by bank", title: "Rejected by Bank" },
  { [Constants.MONGOOSE_ID]: "denied by customer", title: "Denied by Customer" },
];

const LOAN_TYPE_FILTER_OPTIONS = [
  { [Constants.MONGOOSE_ID]: "all", title: "All Loans" },
  { [Constants.MONGOOSE_ID]: "home", title: "Home Loan" },
  { [Constants.MONGOOSE_ID]: "personal", title: "Personal Loan" },
  { [Constants.MONGOOSE_ID]: "business", title: "Business Loan" },
  { [Constants.MONGOOSE_ID]: "car", title: "Car Loan" },
  { [Constants.MONGOOSE_ID]: "education", title: "Education Loan" },
  { [Constants.MONGOOSE_ID]: "credit", title: "Credit Card" },
  { [Constants.MONGOOSE_ID]: "loanAgainstProperty", title: "Loan Against Property" },
  { [Constants.MONGOOSE_ID]: "loanAgainstSecurity", title: "Loan Against Security" },
  { [Constants.MONGOOSE_ID]: "workingCapital", title: "Working Capital" },
  { [Constants.MONGOOSE_ID]: "machinery", title: "Machinery Loan" },
  { [Constants.MONGOOSE_ID]: "gold", title: "Gold Loan" },
];

export default function InquiryListing() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const inquiryState = useSelector((state) => state.inquiry);
  const inquiries = inquiryState?.inquiries || [];
  const loading = inquiryState?.loading || "idle";

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);

  const [editModal, setEditModal] = useState({ open: false, inquiry: null, loading: false });
  const [processModal, setProcessModal] = useState({ open: false, inquiry: null, loading: false });
  const [rejectModal, setRejectModal] = useState({ open: false, inquiry: null, loading: false });
  const [deleteModal, setDeleteModal] = useState({ open: false, inquiry: null, loading: false });

  const initialStatus = location?.state?.status || "all";
  const [statusFilter, setStatusFilter] = useState(initialStatus);
  const [loanTypeFilter, setLoanTypeFilter] = useState("all");
  const [salesManagerFilter, setSalesManagerFilter] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  const [tablePagination, setTablePagination] = useState({
    page: 0,
    perPage: defaultData.DATE_ON_SINGLE_API_CALL,
  });
  const [next, setNext] = useState(0);

  const buildInquiryParams = (
    page = 0,
    perPage = tablePagination.perPage,
    status = statusFilter,
    loanType = loanTypeFilter,
    salesManager = salesManagerFilter,
    search = searchValue
  ) => {
    const queryParts = [
      `page=${page}`,
      `perPage=${perPage}`,
      status && status !== "all" && status !== "undefined"
        ? `status=${encodeURIComponent(status)}`
        : null,
      loanType && loanType !== "all" && loanType !== "undefined"
        ? `loanType=${encodeURIComponent(loanType)}`
        : null,
      salesManager && salesManager !== "all" && salesManager !== "undefined"
        ? `salesManager=${encodeURIComponent(salesManager)}`
        : null,
      search && typeof search === "string" && search.trim() !== ""
        ? `search=${encodeURIComponent(search.trim())}`
        : null,
    ].filter(Boolean);

    return queryParts.join("&");
  };

  const handleFilter = async (
    status = statusFilter,
    loanType = loanTypeFilter,
    salesManager = salesManagerFilter,
    search = searchValue
  ) => {
    setTablePagination((prev) => ({ ...prev, page: 0 }));
    setNext(0);
    const queryString = buildInquiryParams(
      0,
      tablePagination.perPage,
      status,
      loanType,
      salesManager,
      search
    );
    await dispatch(getAllInquiriesThunk(queryString));
  };

  useEffect(() => {
    handleFilter();
  }, []);

  useEffect(() => {
    if (location?.state?.status && location.state.status !== statusFilter) {
      setStatusFilter(location.state.status);
      handleFilter(location.state.status, loanTypeFilter, salesManagerFilter, searchValue);
    }
  }, [location?.state?.status]);

  const handleTablePagination = async () => {
    const queryString = buildInquiryParams(
      next + 1,
      tablePagination.perPage,
      statusFilter,
      loanTypeFilter,
      salesManagerFilter,
      searchValue
    );
    const res = await dispatch(getAllInquiriesThunk(queryString));
    if (res?.payload?.status === 200) {
      const items = res.payload.data?.data || res.payload.data || [];
      setNext(items.length > 0 ? next + 1 : next);
    }
  };

  const [salesManagerOptions, setSalesManagerOptions] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await dispatch(getAllSalesManagers(paramCreater({ isActive: true })));
        if (res?.payload?.status === 200 && res?.payload?.data?.data) {
          const list = res.payload.data.data.map((item) => ({
            [Constants.MONGOOSE_ID]: item[Constants.MONGOOSE_ID] || item._id,
            id: item[Constants.MONGOOSE_ID] || item._id,
            title: item.sm,
          }));
          setSalesManagerOptions(list);
        }
      } catch (err) {
        console.error("Failed to fetch sales managers:", err);
      }
    })();
  }, [dispatch]);

  const salesManagerFilterMenu = useMemo(
    () => [
      { [Constants.MONGOOSE_ID]: "all", title: "All" },
      ...salesManagerOptions.map((item) => ({
        [Constants.MONGOOSE_ID]: item[Constants.MONGOOSE_ID] || item.id,
        title: item.title,
      })),
    ],
    [salesManagerOptions]
  );

  // Handle Add Inquiry
  const handleCreateInquiry = async (formData) => {
    try {
      setCreateLoading(true);
      const res = await dispatch(createInquiryThunk(formData));
      if (res?.payload?.status === 200 || res?.payload?.data) {
        dispatch(
          openSnackbar({
            message: "Inquiry created successfully!",
            notificationType: Constants.NOTIFICATION_SUCCESS,
          })
        );
        setAddModalOpen(false);
        handleFilter();
      } else {
        dispatch(
          openSnackbar({
            message: res?.payload?.data?.message || "Failed to create inquiry",
            notificationType: Constants.NOTIFICATION_ERROR,
          })
        );
      }
    } catch (err) {
      dispatch(
        openSnackbar({
          message: "Something went wrong",
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    } finally {
      setCreateLoading(false);
    }
  };

  // Process Inquiry: navigates to Lead Bay and auto-opens form with prefill; status updates upon form submission
  const handleConfirmProcess = (inquiry, selectedLoanType) => {
    try {
      const inquiryId = inquiry?._id || inquiry?.id;

      setProcessModal({ open: false, inquiry: null, loading: false });

      // Build prefill payload matching LeadBayForm properties
      const prefillPayload = {
        inquiryId,
        inquiryMongoId: inquiryId,
        inquiryNumber: inquiry?.inquiryId,
        firstName: inquiry?.firstName || "",
        lastName: inquiry?.lastName || "",
        mobileNumber: inquiry?.mobileNumber || "",
        imd: inquiry?.imd || "",
        loanAmount: inquiry?.loanAmount || "",
        leadDate: inquiry?.leadDate || "",
        loanType: selectedLoanType,
        // Loan-specific fields
        email: inquiry?.email || "",
        modelOfCar: inquiry?.modelOfCar || inquiry?.carModel || "",
        carLoanType: inquiry?.carLoanType || inquiry?.carType || "",
        universityLetterReceived: inquiry?.universityLetterReceived || "",
        countryApplyingFor: inquiry?.countryApplyingFor || inquiry?.countryOfApplication || "",
      };

      if (inquiryId) {
        sessionStorage.setItem("finvibes_active_inquiry_id", inquiryId);
      }
      if (selectedLoanType) {
        sessionStorage.setItem("finvibes_active_inquiry_loan_type", selectedLoanType);
      }

      dispatch(
        openSnackbar({
          message: "Redirecting to Lead Bay with pre-filled details...",
          notificationType: Constants.NOTIFICATION_SUCCESS,
        })
      );

      navigate("/client/lead-bay", {
        state: {
          prefillData: prefillPayload,
          inquiryId,
          loanType: selectedLoanType,
        },
      });
    } catch (err) {
      setProcessModal({ open: false, inquiry: null, loading: false });
      dispatch(
        openSnackbar({
          message: "Something went wrong",
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    }
  };

  // Handle Process Modal Status (Rejected by Bank / Denied by Customer)
  const handleProcessModalReject = async (inquiry, statusType, remarks) => {
    try {
      setProcessModal((prev) => ({ ...prev, loading: true }));
      const inquiryId = inquiry?._id || inquiry?.id;
      const normalizedStatus = (statusType || "").toLowerCase().trim();
      let statusTitle = statusType;
      if (normalizedStatus === "rejected by bank") {
        statusTitle = "Rejected by Bank";
      } else if (normalizedStatus === "denied by customer") {
        statusTitle = "Denied by Customer";
      }

      const trimmedRemarks =
        remarks && typeof remarks === "string" && remarks.trim() !== "" ? remarks.trim() : null;

      const res = await dispatch(
        updateInquiryStatusThunk({
          id: inquiryId,
          status: normalizedStatus,
          rejectionReason: trimmedRemarks,
        })
      );

      if (res?.payload?.status === 200 || res?.payload?.data) {
        dispatch(
          openSnackbar({
            message: `Inquiry marked as ${statusTitle} successfully`,
            notificationType: Constants.NOTIFICATION_SUCCESS,
          })
        );
        if (res?.payload?.data?.data) {
          dispatch(updateInquiryInList(res.payload.data.data));
        }
        setProcessModal({ open: false, inquiry: null, loading: false });
        handleFilter();
      } else {
        dispatch(
          openSnackbar({
            message: res?.payload?.data?.message || `Failed to update inquiry to ${statusType}`,
            notificationType: Constants.NOTIFICATION_ERROR,
          })
        );
        setProcessModal((prev) => ({ ...prev, loading: false }));
      }
    } catch (err) {
      setProcessModal((prev) => ({ ...prev, loading: false }));
      dispatch(
        openSnackbar({
          message: "Something went wrong while updating inquiry status",
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    }
  };

  // Reject Inquiry
  const handleConfirmReject = async (inquiry, rejectionReason) => {
    try {
      setRejectModal((prev) => ({ ...prev, loading: true }));
      const inquiryId = inquiry?._id || inquiry?.id;

      const res = await dispatch(
        updateInquiryStatusThunk({
          id: inquiryId,
          status: "rejected",
          rejectionReason,
        })
      );

      if (res?.payload?.status === 200 || res?.payload?.data) {
        dispatch(
          openSnackbar({
            message: "Inquiry marked as Rejected",
            notificationType: Constants.NOTIFICATION_SUCCESS,
          })
        );
        if (res?.payload?.data?.data) {
          dispatch(updateInquiryInList(res.payload.data.data));
        }
        setRejectModal({ open: false, inquiry: null, loading: false });
        handleFilter();
      } else {
        dispatch(
          openSnackbar({
            message: res?.payload?.data?.message || "Failed to reject inquiry",
            notificationType: Constants.NOTIFICATION_ERROR,
          })
        );
        setRejectModal((prev) => ({ ...prev, loading: false }));
      }
    } catch (err) {
      setRejectModal((prev) => ({ ...prev, loading: false }));
      dispatch(
        openSnackbar({
          message: "Something went wrong",
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    }
  };

  // Delete Inquiry
  const handleConfirmDelete = async () => {
    try {
      setDeleteModal((prev) => ({ ...prev, loading: true }));
      const inquiryId = deleteModal.inquiry?._id || deleteModal.inquiry?.id;

      const res = await dispatch(deleteInquiryThunk(inquiryId));
      if (res?.payload?.status === 200 || res?.payload?.data) {
        dispatch(
          openSnackbar({
            message: "Inquiry deleted successfully",
            notificationType: Constants.NOTIFICATION_SUCCESS,
          })
        );
        dispatch(removeInquiryFromList(inquiryId));
        setDeleteModal({ open: false, inquiry: null, loading: false });
        handleFilter();
      } else {
        dispatch(
          openSnackbar({
            message: res?.payload?.data?.message || "Failed to delete inquiry",
            notificationType: Constants.NOTIFICATION_ERROR,
          })
        );
        setDeleteModal((prev) => ({ ...prev, loading: false }));
      }
    } catch (err) {
      setDeleteModal((prev) => ({ ...prev, loading: false }));
      dispatch(
        openSnackbar({
          message: "Something went wrong",
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    }
  };

  const searchTimeoutRef = useRef(null);

  // Reset Filters
  const handleResetFilters = () => {
    setStatusFilter("all");
    setLoanTypeFilter("all");
    setSalesManagerFilter("all");
    setSearchValue("");
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    handleFilter("all", "all", "all", "");
  };

  const handleStatusFilterChange = (e) => {
    const val = e?.target ? e.target.value : e;
    setStatusFilter(val);
    handleFilter(val, loanTypeFilter, salesManagerFilter, searchValue);
  };

  const handleLoanTypeFilterChange = (e) => {
    const val = e?.target ? e.target.value : e;
    setLoanTypeFilter(val);
    handleFilter(statusFilter, val, salesManagerFilter, searchValue);
  };

  const handleSalesManagerFilterChange = (e) => {
    const val = e?.target ? e.target.value : e;
    setSalesManagerFilter(val);
    handleFilter(statusFilter, loanTypeFilter, val, searchValue);
  };

  const handleSearchKeyUp = (e) => {
    const text = e?.target?.value !== undefined ? e.target.value : "";
    setSearchValue(text);
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    searchTimeoutRef.current = setTimeout(() => {
      handleFilter(statusFilter, loanTypeFilter, salesManagerFilter, text);
    }, 400);
  };

  const handleSearchClearOrSelect = (event, selectedLabel) => {
    const text = selectedLabel || "";
    setSearchValue(text);
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    handleFilter(statusFilter, loanTypeFilter, salesManagerFilter, text);
  };

  // Edit Inquiry
  const handleConfirmEdit = async (formData) => {
    try {
      setEditModal((prev) => ({ ...prev, loading: true }));
      const inquiryId = editModal.inquiry?._id || editModal.inquiry?.id;

      const res = await dispatch(
        updateInquiryThunk({
          id: inquiryId,
          data: formData,
        })
      );

      if (
        res?.payload?.status === 200 ||
        res?.payload?.data?.status === 200 ||
        res?.payload?.data
      ) {
        dispatch(
          openSnackbar({
            message: "Inquiry updated successfully!",
            notificationType: Constants.NOTIFICATION_SUCCESS,
          })
        );
        if (res?.payload?.data?.data) {
          dispatch(updateInquiryInList(res.payload.data.data));
        }
        setEditModal({ open: false, inquiry: null, loading: false });
        handleFilter();
      } else {
        dispatch(
          openSnackbar({
            message: res?.payload?.data?.message || "Failed to update inquiry",
            notificationType: Constants.NOTIFICATION_ERROR,
          })
        );
        setEditModal((prev) => ({ ...prev, loading: false }));
      }
    } catch (err) {
      setEditModal((prev) => ({ ...prev, loading: false }));
      dispatch(
        openSnackbar({
          message: "Something went wrong",
          notificationType: Constants.NOTIFICATION_ERROR,
        })
      );
    }
  };

  const userRole = (Session.userRole || "").toLowerCase();
  const isAdmin =
    userRole === (defaultData.ADMIN_ROLE || "admin").toLowerCase() ||
    userRole === (defaultData.SUPER_ADMIN_ROLE || "superadmin").toLowerCase();

  const { columns, rows } = inquiriesTableData(
    inquiries,
    (inquiry) => setProcessModal({ open: true, inquiry, loading: false }),
    (inquiry) => setRejectModal({ open: true, inquiry, loading: false }),
    (inquiry) => setDeleteModal({ open: true, inquiry, loading: false }),
    (inquiry) => setEditModal({ open: true, inquiry, loading: false }),
    isAdmin
  );

  return (
    <>
      {/* Top action bar */}
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1.5}
        sx={{ width: "100%", mb: 2.5 }}
      >
        <Typography sx={{ fontSize: pxToRem(20), fontWeight: 700, color: "#101828" }}>
          Inquiries
        </Typography>

        <MDBox display="flex" alignItems="center" gap={1.5}>
          <Button
            variant="contained"
            onClick={() => setAddModalOpen(true)}
            startIcon={<AddIcon sx={{ color: "#FFFFFF !important" }} />}
            sx={{
              height: pxToRem(42),
              px: pxToRem(18),
              backgroundColor: "#0047B3",
              color: "#FFFFFF",
              borderRadius: pxToRem(6),
              boxShadow: "none",
              fontSize: pxToRem(14),
              fontWeight: 500,
              textTransform: "none",
              "& .MuiButton-startIcon": {
                color: "#FFFFFF !important",
              },
              "&:hover": {
                backgroundColor: "#003580",
                boxShadow: "none",
              },
            }}
          >
            Add Inquiry
          </Button>
          <ResetFilterButton handleReset={handleResetFilters} marginTop={0} />
        </MDBox>
      </MDBox>

      {/* Filters & Search row */}
      <MDBox
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        gap={1.5}
        sx={{ mb: 2, width: "100%" }}
      >
        <FilterDropdown
          label="Status"
          name="status"
          defaultValue={statusFilter}
          value={statusFilter}
          handleChange={handleStatusFilterChange}
          menu={STATUS_FILTER_OPTIONS}
          minWidth={140}
        />

        <FilterDropdown
          label="Loan Type"
          name="loanType"
          defaultValue={loanTypeFilter}
          value={loanTypeFilter}
          handleChange={handleLoanTypeFilterChange}
          menu={LOAN_TYPE_FILTER_OPTIONS}
          minWidth={170}
        />

        <FilterDropdown
          label="Sales Manager"
          name="salesManager"
          defaultValue={salesManagerFilter}
          value={salesManagerFilter}
          handleChange={handleSalesManagerFilterChange}
          menu={salesManagerFilterMenu}
          minWidth={170}
        />

        <CustomSearch
          isLoading={loading === Constants.PENDING}
          options={[]}
          value={searchValue}
          debouncedHandleSearch={handleSearchKeyUp}
          handleFilterChange={handleSearchClearOrSelect}
          placeholder="Search Name, Phone, IMD"
          label="Search"
          width={pxToRem(260)}
          freeSolos
        />
      </MDBox>

      {/* Inquiries DataTable */}
      <MDBox mt={2}>
        <DataTable
          table={{ columns, rows }}
          isSorted={false}
          entriesPerPage={{ defaultValue: defaultData.PER_PAGE }}
          showTotalEntries={false}
          noEndBorder
          loading={loading}
          handleTablePagination={handleTablePagination}
          currentPage={tablePagination.page}
          handleCurrentPage={(page) => setTablePagination({ ...tablePagination, page })}
        />
      </MDBox>

      {/* Add Inquiry Modal */}
      {addModalOpen && (
        <AddInquiryModal
          open={addModalOpen}
          handleClose={() => setAddModalOpen(false)}
          handleSubmit={handleCreateInquiry}
          loading={createLoading}
          salesManagerOptions={salesManagerOptions}
        />
      )}

      {/* Edit Inquiry Modal */}
      {editModal.open && (
        <EditInquiryModal
          open={editModal.open}
          inquiry={editModal.inquiry}
          handleClose={() => setEditModal({ open: false, inquiry: null, loading: false })}
          handleSubmit={handleConfirmEdit}
          loading={editModal.loading}
          salesManagerOptions={salesManagerOptions}
        />
      )}

      {/* Process Inquiry Modal */}
      {processModal.open && (
        <ProcessInquiryModal
          open={processModal.open}
          inquiry={processModal.inquiry}
          handleClose={() => setProcessModal({ open: false, inquiry: null, loading: false })}
          handleConfirmProcess={handleConfirmProcess}
          handleRejectStatus={handleProcessModalReject}
          loading={processModal.loading}
        />
      )}

      {/* Reject Inquiry Modal */}
      {rejectModal.open && (
        <RejectInquiryModal
          open={rejectModal.open}
          inquiry={rejectModal.inquiry}
          handleClose={() => setRejectModal({ open: false, inquiry: null, loading: false })}
          handleConfirmReject={handleConfirmReject}
          loading={rejectModal.loading}
        />
      )}

      {/* Delete Confirmation Modal */}
      {deleteModal.open && (
        <ConfirmationModal
          open={deleteModal.open}
          handleClose={() => setDeleteModal({ open: false, inquiry: null, loading: false })}
          title="Delete Inquiry"
          message="Are you sure you want to delete this inquiry? This action cannot be undone."
          handleAction={handleConfirmDelete}
        />
      )}
    </>
  );
}
